import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/CV-ROVERE.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", { href: "https://www.linkedin.com/in/alex-rovere-906089207/" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Linkedin")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid w-75",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
}